import api from "@/services/api";

const { get } = api.getPrefixedMethods("provider-delegate-agreements");

export default {
  list({ page, pageSize, search } = {}) {
    return get("", { params: { page, pageSize, search: search || undefined } });
  },
};
